import { Temporal } from '@js-temporal/polyfill'

/** Reference timezone for player URLs, independent of the browser or camera. */
export const projectTimezone = 'America/Chicago'

export function formatPlayerAt(ms: number) {
  const time = Temporal.Instant.fromEpochMilliseconds(
    Math.floor(ms / 1000) * 1000,
  ).toZonedDateTimeISO(projectTimezone)
  const local = time.toPlainDateTime()
  const value = local
    .toString({ smallestUnit: 'second' })
    .replace('T', '_')
    .replaceAll(':', '-')
  // Only the second occurrence of a repeated fall-back time needs an offset.
  const earlier = local.toZonedDateTime(projectTimezone, { disambiguation: 'earlier' })
  return (
    value +
    (earlier.epochMilliseconds === time.epochMilliseconds
      ? ''
      : time.offset.replace(':', ''))
  )
}

export function parsePlayerAt(value: string) {
  const match = /^(\d{4}-\d{2}-\d{2})_(\d{2})-(\d{2})-(\d{2})([+-]\d{4})?$/.exec(value)
  if (!match) return Date.parse(value)
  const [, date, hour, minute, second, offset] = match
  const local = `${date}T${hour}:${minute}:${second}`
  try {
    if (offset) {
      return Temporal.ZonedDateTime.from(`${local}${offset}[${projectTimezone}]`)
        .epochMilliseconds
    }
    const plain = Temporal.PlainDateTime.from(local)
    const zoned = plain.toZonedDateTime(projectTimezone, {
      disambiguation: 'earlier',
    })
    return zoned.toPlainDateTime().equals(plain) ? zoned.epochMilliseconds : NaN
  } catch {
    return NaN
  }
}

export function setPlayerPosition(url: URL, camera: string, ms: number) {
  url.searchParams.delete('day')
  url.searchParams.set('camera', camera)
  url.searchParams.set('at', formatPlayerAt(ms))
}
